import React from 'react'
import 'react-vis/dist/style.css'
import {
  FlexibleWidthXYPlot,
  VerticalGridLines,
  HorizontalGridLines,
  AreaSeries,
  DiscreteColorLegend,
  Crosshair,
  XAxis
} from 'react-vis'

const DATA = [
  [
    { x: 'VGA', y: 3 },
    { x: '720p', y: 8 },
    { x: '1080p', y: 25 }
  ],
  [
    { x: 'VGA', y: 8.5 },
    { x: '720p', y: 10 },
    { x: '1080p', y: 30 }
  ]
];


export default class Example extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      crosshairValues: []
    };
  }

  render() {
    return (
      <React.Fragment>

        <div className="chart">
          <FlexibleWidthXYPlot
            onMouseLeave={() => this.setState({ crosshairValues: [] })}
            height={300}
            xType="ordinal"
            stackBy="y">

            <XAxis
              attr="x"
              attrAxis="y"
              orientation="bottom"
            />

            <VerticalGridLines />

            <HorizontalGridLines />

            <AreaSeries
              onNearestX={(value, { index }) =>
                this.setState({ crosshairValues: DATA.map(d => d[index]) })}
              cluster="ProcessorLoad"
              color="#1274d3"
              curve="curveNatural"
              data={DATA[0]} />

            <AreaSeries
              cluster="ProcessorLoad"
              color="#efac59"
              curve="curveNatural"
              data={DATA[1]} />

            <Crosshair values={this.state.crosshairValues} />

          </FlexibleWidthXYPlot>
        </div>

        <div className="legend">
          <DiscreteColorLegend
            orientation="horizontal"
            items={[
              {
                title: '[0] Single Camera Load',
                color: '#1274d3'
              },
              {
                title: '[1] Double Camera Load',
                color: '#efac59'
              }
            ]}
          />
        </div>

      </React.Fragment>
    );
  }
}